module.exports = __webpack_public_path__ + "img/img14.a6f603f7.svg";